import React from 'react';
import { observer } from 'mobx-react';
import CompanyLogoPlaceholder from '../../../../assets/images/boardtrac_plus_logo.svg';

const CompanyCard = observer(
    class CompanyCard extends React.Component {
        mouseOver = () => {
            let style = getComputedStyle(document.body);
            this.css = style.getPropertyValue('--company-hover-color');
            document.documentElement.style.setProperty(
                '--company-hover-color',
                this.props.details.Hex,
            );
        };

        mouseOut = () => {
            document.documentElement.style.setProperty('--group-hover-color', this.css || 'red');
        };

        onClick = e => {
            if (this.props.onClick) {
                this.props.onClick(this.props.index, e);
            }
        };

        render() {
            const { details, selected, logo } = this.props;
            let cardClass = 'card' + (selected ? ' selected' : '');
            return (
                <div
                    ref={card => (this.card = card)}
                    className=""
                    onClick={this.onClick}
                    onMouseOver={this.mouseOver}
                    onMouseOut={this.mouseOut}
                    onMouseDown={this.mouseDown}
                    onMouseUp={this.onMouseUp}
                    onTouchMove={this.touchMove}
                >
                    <div className={cardClass}>
                        {details.hasNewItems && <span className="badge badge-primary">New</span>}
                        <img
                            draggable={false}
                            src={logo ? logo : CompanyLogoPlaceholder}
                            className="img-fluid"
                            alt={details.DisplayName}
                            title={details.DisplayName}
                        />
                    </div>
                </div>
            );
        }
    },
);

export default CompanyCard;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Company/components/CompanyCard.js